"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackofficePendingOrderResponseDtoToJSON = exports.BackofficePendingOrderResponseDtoFromJSONTyped = exports.BackofficePendingOrderResponseDtoFromJSON = exports.instanceOfBackofficePendingOrderResponseDto = exports.BackofficePendingOrderResponseDtoOrderTypeEnum = exports.BackofficePendingOrderResponseDtoStatusEnum = void 0;
var runtime_1 = require("../runtime");
var RequisitionInfoDto_1 = require("./RequisitionInfoDto");
/**
 * @export
 */
exports.BackofficePendingOrderResponseDtoStatusEnum = {
    Pending: 'pending',
    Started: 'started',
    Error: 'error',
    Success: 'success'
};
/**
 * @export
 */
exports.BackofficePendingOrderResponseDtoOrderTypeEnum = {
    Hcx: 'hcx',
    Hcp: 'hcp'
};
/**
 * Check if a given object implements the BackofficePendingOrderResponseDto interface.
 */
function instanceOfBackofficePendingOrderResponseDto(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "requisitions" in value;
    isInstance = isInstance && "celeryTaskId" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "orderType" in value;
    return isInstance;
}
exports.instanceOfBackofficePendingOrderResponseDto = instanceOfBackofficePendingOrderResponseDto;
function BackofficePendingOrderResponseDtoFromJSON(json) {
    return BackofficePendingOrderResponseDtoFromJSONTyped(json, false);
}
exports.BackofficePendingOrderResponseDtoFromJSON = BackofficePendingOrderResponseDtoFromJSON;
function BackofficePendingOrderResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'requisitions': (json['requisitions'].map(RequisitionInfoDto_1.RequisitionInfoDtoFromJSON)),
        'celeryTaskId': json['celeryTaskId'],
        'dateCreated': json['dateCreated'],
        'orderType': json['orderType'],
        'statusLastUpdated': !(0, runtime_1.exists)(json, 'statusLastUpdated') ? undefined : json['statusLastUpdated'],
        'errorMessage': !(0, runtime_1.exists)(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}
exports.BackofficePendingOrderResponseDtoFromJSONTyped = BackofficePendingOrderResponseDtoFromJSONTyped;
function BackofficePendingOrderResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': value.status,
        'requisitions': (value.requisitions.map(RequisitionInfoDto_1.RequisitionInfoDtoToJSON)),
        'celeryTaskId': value.celeryTaskId,
        'dateCreated': value.dateCreated,
        'orderType': value.orderType,
        'statusLastUpdated': value.statusLastUpdated,
        'errorMessage': value.errorMessage,
    };
}
exports.BackofficePendingOrderResponseDtoToJSON = BackofficePendingOrderResponseDtoToJSON;
